<template>
  <div class="subproPage">
     <Slider></Slider>
     <Header></Header>
     <Subpro></Subpro>
  </div>
</template>
<script>
   import Slider from '@/components/layout/slider.vue';
  import Header from '@/components/layout/header.vue';
  import Subpro from '../subpro.vue';

  export default {
    data() {
      return {
        
      }
    },
    computed: {
      
    },
    methods:{
      
    },
    components:{
      Header,Slider,Subpro
    }
  };

</script>


<style scoped lang="scss">
  .aside{
    float: left;
  }
  .el-header{
    margin-left: 2.87rem;
    /*position: relative;*/
    }
  .subpro{
    float: left;
    margin: 0.22rem 0 0 0.31rem;
    /*position: absolute;
    top: 1rem;
    left: 3.18rem;*/
  }
</style>




// WEBPACK FOOTER //
// src/views/subproPage/Subpro.vue